export const COLUMNS_HEADERS = {
  docket_number: {
    searchable: true,
    sortable: true,
    ascSort: true,
  },
  arriving_date: { sortable: true },
};
